const COLUMNS = [
  {
    name: "Chamados abertos",
    color: "#FF5C00",
    count: 12,
    cards: [
      { t: "Vazamento — Apt 42", tag: "Hidráulica", time: "há 12 min" },
      { t: "Tomada sem energia", tag: "Elétrica", time: "há 40 min" },
    ],
  },
  {
    name: "Em análise",
    color: "#8B5CF6",
    count: 7,
    cards: [
      { t: "Infiltração no teto", tag: "Vistoria", time: "há 1 h" },
      { t: "Portão da garagem", tag: "Reparo", time: "há 2 h" },
    ],
  },
  {
    name: "Orçamento",
    color: "#F59E0B",
    count: 5,
    cards: [{ t: "Pintura completa — Casa 8", tag: "Pintura", time: "há 3 h" }],
  },
  {
    name: "Aguardando aprovação",
    color: "#EC4899",
    count: 3,
    cards: [{ t: "Troca de fechaduras", tag: "Segurança", time: "há 5 h" }],
  },
  {
    name: "Em execução",
    color: "#FF8A3D",
    count: 9,
    cards: [
      { t: "Reparo em telhado", tag: "Alvenaria", time: "hoje" },
      { t: "Desocupação — Apt 1204", tag: "Vistoria", time: "hoje" },
    ],
  },
  {
    name: "Concluídos",
    color: "#10B981",
    count: 128,
    cards: [
      { t: "Reparo em armários", tag: "Marcenaria", time: "ontem" },
      { t: "Revisão elétrica", tag: "Elétrica", time: "ontem" },
    ],
  },
];

export const DashboardMock = () => (
  <div
    data-testid="tech-dashboard-mock"
    className="overflow-hidden rounded-2xl border border-white/10 bg-petrol-800 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)]"
  >
    <div className="flex items-center gap-3 border-b border-white/10 px-5 py-3.5">
      <div className="flex gap-1.5">
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      </div>
      <div className="flex-1 text-center">
        <span className="rounded-md bg-white/5 px-4 py-1 font-mono text-[0.65rem] tracking-widest text-white/50">
          painel.resolv.com.br
        </span>
      </div>
      <span className="inline-flex items-center gap-1.5 font-mono text-[0.6rem] uppercase tracking-widest text-emerald-400">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
        sync
      </span>
    </div>
    <div className="overflow-x-auto p-5">
      <div className="flex min-w-[900px] gap-3">
        {COLUMNS.map((col) => (
          <div key={col.name} className="flex-1 rounded-xl bg-white/[0.04] p-3" data-testid={`dash-col-${col.name}`}>
            <div className="mb-3 flex items-center justify-between px-1">
              <span className="flex items-center gap-2 text-[0.7rem] font-semibold text-white/80">
                <span className="h-2 w-2 rounded-full" style={{ backgroundColor: col.color }} />
                {col.name}
              </span>
              <span className="rounded-full bg-white/10 px-2 py-0.5 font-mono text-[0.65rem] text-white/70">
                {col.count}
              </span>
            </div>
            <div className="space-y-2">
              {col.cards.map((card) => (
                <div
                  key={card.t}
                  className="rounded-lg border border-white/[0.07] bg-petrol p-3 transition-colors duration-300 hover:border-brand/50"
                >
                  <p className="text-xs font-semibold leading-snug text-white">{card.t}</p>
                  <div className="mt-2 flex items-center justify-between">
                    <span
                      className="rounded-full px-2 py-0.5 text-[0.6rem] font-semibold"
                      style={{ backgroundColor: `${col.color}22`, color: col.color }}
                    >
                      {card.tag}
                    </span>
                    <span className="font-mono text-[0.6rem] text-white/40">{card.time}</span>
                  </div>
                </div>
              ))}
              <div className="rounded-lg border border-dashed border-white/10 p-2.5 text-center font-mono text-[0.6rem] uppercase tracking-widest text-white/25">
                + demanda
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
